/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { PaginatedResponse_PerformanceClassResponse_ } from '../models/PaginatedResponse_PerformanceClassResponse_';
import type { PerformanceClassCreateRequest } from '../models/PerformanceClassCreateRequest';
import type { PerformanceClassResponse } from '../models/PerformanceClassResponse';
import type { PerformanceClassSortRequest } from '../models/PerformanceClassSortRequest';
import type { PerformanceClassUpdateRequest } from '../models/PerformanceClassUpdateRequest';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class PerformanceClassService {
    /**
     * Create Performance Class
     * 성과지표 생성
     *
     * 새로운 성과지표를 생성합니다.
     * @returns PerformanceClassResponse Created
     * @throws ApiError
     */
    public static appsPerformanceViewsCreatePerformanceClass({
        requestBody,
    }: {
        requestBody: PerformanceClassCreateRequest,
    }): CancelablePromise<PerformanceClassResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/performance/class',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                409: `Conflict`,
                500: `Internal Server Error`,
            },
        });
    }
    /**
     * List Performance Classes
     * 성과지표 목록 조회 및 검색
     *
     * 성과지표를 페이징하여 조회합니다. 검색 키워드가 제공되면 검색을 수행합니다.
     *
     * Args:
     * performance_category_id: 성과 분류 ID로 필터링 (선택사항)
     * q: 검색 키워드 (선택사항) - 지표명으로 검색
     * @returns PaginatedResponse_PerformanceClassResponse_ OK
     * @throws ApiError
     */
    public static appsPerformanceViewsListPerformanceClasses({
        performanceCategoryId,
        q,
        page = 1,
        perPage = 100,
    }: {
        performanceCategoryId?: string,
        q?: string,
        page?: number,
        perPage?: number,
    }): CancelablePromise<PaginatedResponse_PerformanceClassResponse_> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/performance/class',
            query: {
                'performance_category_id': performanceCategoryId,
                'q': q,
                'page': page,
                'per_page': perPage,
            },
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                404: `Not Found`,
                500: `Internal Server Error`,
            },
        });
    }
    /**
     * Get Performance Class
     * 성과지표 조회
     *
     * ID로 특정 성과지표를 조회합니다.
     * @returns PerformanceClassResponse OK
     * @throws ApiError
     */
    public static appsPerformanceViewsGetPerformanceClass({
        classId,
    }: {
        classId: string,
    }): CancelablePromise<PerformanceClassResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/performance/class/{class_id}',
            path: {
                'class_id': classId,
            },
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                404: `Not Found`,
                500: `Internal Server Error`,
            },
        });
    }
    /**
     * Update Performance Class
     * 성과지표 정보 수정
     *
     * 특정 성과지표의 정보를 수정합니다.
     * @returns PerformanceClassResponse OK
     * @throws ApiError
     */
    public static appsPerformanceViewsUpdatePerformanceClass({
        classId,
        requestBody,
    }: {
        classId: string,
        requestBody: PerformanceClassUpdateRequest,
    }): CancelablePromise<PerformanceClassResponse> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/performance/class/{class_id}',
            path: {
                'class_id': classId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                404: `Not Found`,
                500: `Internal Server Error`,
            },
        });
    }
    /**
     * Delete Performance Class
     * 성과지표 삭제
     *
     * 특정 성과지표를 삭제합니다. (소프트 삭제)
     * @returns void
     * @throws ApiError
     */
    public static appsPerformanceViewsDeletePerformanceClass({
        classId,
    }: {
        classId: string,
    }): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/api/performance/class/{class_id}',
            path: {
                'class_id': classId,
            },
            errors: {
                401: `Unauthorized`,
                404: `Not Found`,
                500: `Internal Server Error`,
            },
        });
    }
    /**
     * Update Performance Class Sort
     * 성과지표 정렬 순서 변경
     *
     * 성과지표의 정렬 순서를 변경합니다.
     * prev_class_id: 이동할 위치의 이전 성과지표 ID (맨 앞이면 None)
     * next_class_id: 이동할 위치의 다음 성과지표 ID (맨 뒤면 None)
     * @returns PerformanceClassResponse OK
     * @throws ApiError
     */
    public static appsPerformanceViewsUpdatePerformanceClassSort({
        classId,
        requestBody,
    }: {
        classId: string,
        requestBody: PerformanceClassSortRequest,
    }): CancelablePromise<PerformanceClassResponse> {
        return __request(OpenAPI, {
            method: 'PATCH',
            url: '/api/performance/class/{class_id}/sort',
            path: {
                'class_id': classId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                404: `Not Found`,
                500: `Internal Server Error`,
            },
        });
    }
}
